import { Routes } from '@angular/router';
import { MultiTraitQueryComponent } from './multi-trait-query.component';
import { CategoricalTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/categorical-traits-pane.component';
import { CharacterTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/character-traits-pane.component';
import { NumberTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/number-traits-pane.component';
import { LocationFilterPopupComponent } from '../shared/query/location-filter.component';
import { StudyFilterPopupComponent } from '../shared/query/study-filter.component';
import { MULTI_TRAIT_QUERY_PERMISSIONS } from '../shared/auth/permissions';
import { RouteAccessService } from '../shared';
import { TraitObservationPopupComponent } from './setup-trait-filter-step-panel/traits-panel/trait-observation/trait-observation.component';


export const MULTI_TRAIT_QUERY_ROUTES: Routes = [
    {
        path: 'multi-trait-query',
        component: MultiTraitQueryComponent,
        data: { authorities: [...MULTI_TRAIT_QUERY_PERMISSIONS], pageTitle: 'multi-trait-query.title' },
        canActivate: [RouteAccessService],
        children: [
            {
                path: '',
                redirectTo: 'number-traits',
                pathMatch: 'full'
            },
            {
                path: 'number-traits',
                component: NumberTraitsPaneComponent,
                data: { pageTitle: 'multi-trait-query.title' },
            },
            {
                path: 'character-traits',
                component: CharacterTraitsPaneComponent,
                data: { pageTitle: 'multi-trait-query.title' },
            },
            {
                path: 'categorical-traits',
                component: CategoricalTraitsPaneComponent,
                data: { pageTitle: 'multi-trait-query.title' },
            }
        ]
    },
    {
        path: 'environments-location-filter-dialog',
        component: LocationFilterPopupComponent,
        data: { authorities: [...MULTI_TRAIT_QUERY_PERMISSIONS] },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'environments-study-filter-dialog',
        data: { authorities: [...MULTI_TRAIT_QUERY_PERMISSIONS] },
        canActivate: [RouteAccessService],
        component: StudyFilterPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'trait-observation-dialog/:traitId',
        data: { authorities: [...MULTI_TRAIT_QUERY_PERMISSIONS] },
        canActivate: [RouteAccessService],
        component: TraitObservationPopupComponent,
        outlet: 'popup'
    }
];
